import { Button } from "@salutejs/sdds-insol";

import Logo from "../assets/logo.png";
import styles from "./BaseModalWithLogo.module.scss";
import { ModalHeading } from "./ModalHeading";
import { DEFAULT_TITLE, DEFAULT_ACTION_TEXT } from "../model/const";

import type { BaseModalWithLogoProps } from "../model/types";

export const BaseModalWithLogo = ({
    message,
    onActionClick,
    title = DEFAULT_TITLE,
    actionText = DEFAULT_ACTION_TEXT,
}: BaseModalWithLogoProps) => (
    <div className={styles.container}>
        <img className={styles.logo} src={Logo} alt="logo" />
        <ModalHeading className={styles.title} text={title} />
        {message && <div className={styles.message}>{message}</div>}
        <Button stretch view="accent-gradient" size="l" onClick={onActionClick} type="button">
            {actionText}
        </Button>
    </div>
);
